<div class="container-fluid main-page main-page-padding">
    <div class="blocker"></div>
    <div class="top-nav-bar-container">
        <div class="top-nav-bar">
            <span class="title"> KPI Dashboard: {{buyerName}}</span>
            <div class="top-nav-btns">
                <button [ngClass]="defaultPeriodType === 'YTD' ? 'active' : 'inactive'" class="nav-button"
                    (click)="setPeriodType('YTD', false)">YTD</button>
                <button [ngClass]="defaultPeriodType === 'QTD' ? 'active' : 'inactive'" class="nav-button"
                    (click)="setPeriodType('QTD', false)">QTD</button>
                <button [ngClass]="defaultPeriodType === 'MTD' ? 'active' : 'inactive'" class="nav-button"
                    (click)="setPeriodType('MTD', false)">MTD </button>
                <button [ngClass]="defaultPeriodType === 'WTD' ? 'active' : 'inactive'" class="nav-button"
                    (click)="setPeriodType('WTD', false)">WTD</button>
                <button [ngClass]="defaultPeriodType === 'PW' ? 'active' : 'inactive'" class="nav-button"
                    (click)="setPeriodType('WTD', true)">PW</button>
            </div>
        </div>
    </div>

    <div class="page-content-widgets">
        <div #gridContainer class="grid-stack">
            <div class="grid-stack-item" data-gs-id="conversion-target">
                <div class="grid-stack-item-content">
                    <app-card title="Conversion vs target" [currentValue]="76" [changeValue]="-2"
                        [previousValue]="78" [weeklyPledge]="78" [target]="70" [personalBest]="91" [unit]="'%'"
                        [periodType]="defaultPeriodType"></app-card>
                </div>
            </div>
            <div class="grid-stack-item" data-gs-id="cosmetic-grade-match">
                <div class="grid-stack-item-content">
                    <app-card title="Cosmetic grade match" [currentValue]="76" [changeValue]="2"
                        [previousValue]="74" [weeklyPledge]="77" [target]="75" [personalBest]="97" [unit]="'%'"
                        [periodType]="defaultPeriodType"></app-card>
                </div>
            </div>
            <div class="grid-stack-item" data-gs-id="mechanical-grade-match">
                <div class="grid-stack-item-content">
                    <app-card title="Mechanical grade match" [currentValue]="52" [changeValue]="1"
                        [previousValue]="51" [weeklyPledge]="52" [target]="50" [personalBest]="54" [unit]="'%'"
                        [periodType]="defaultPeriodType"></app-card>
                </div>
            </div>
            <div class="grid-stack-item" data-gs-id="avg-time-to-purchase">
                <div class="grid-stack-item-content">
                    <app-card title="Avg. time to purchase" [currentValue]="19" [changeValue]="-1"
                        [previousValue]="20" [weeklyPledge]="18" [target]="20" [personalBest]="16" [unit]="'m'"
                        [periodType]="defaultPeriodType"></app-card>
                </div>
            </div>
            <div class="grid-stack-item" data-gs-id="faster-payment">
                <div class="grid-stack-item-content">
                    <app-card title="Faster payment" [currentValue]="43" [changeValue]="2"
                        [previousValue]="41" [weeklyPledge]="45" [target]="40" [personalBest]="58" [unit]="'%'"
                        [periodType]="defaultPeriodType"></app-card>
                </div>
            </div>
            <div class="grid-stack-item" data-gs-id="customer-score">
                <div class="grid-stack-item-content">
                    <app-card title="Trustpilot penetration" [currentValue]="32" [changeValue]="0"
                        [previousValue]="32" [weeklyPledge]="35" [target]="30" [personalBest]="45" [unit]="'%'"
                        [periodType]="defaultPeriodType"></app-card>
                </div>
            </div>
        </div>
    </div>
    <!-- <div *ngIf="loading" class="text-center">
        <app-loading-wbac-animation></app-loading-wbac-animation>
    </div> -->
</div>